module.exports = __webpack_public_path__ + "img/thumbnail-vrl.c769f774.jpg";